import { type ConsoleApi, type TokenSource } from './client';
import { HttpConsoleApi } from './http';
import { MockConsoleApi } from './mock/api';

export { ApiError, errorMessage, isApiError } from './client';
export type { ConsoleApi } from './client';
export { HttpConsoleApi } from './http';
export { MockConsoleApi } from './mock/api';

export type ApiMode = 'http' | 'mock';

/**
 * Pick the API for this build: the HTTP client when VITE_API_BASE_URL is set, otherwise the
 * in-memory mock. The header shows which one is live so nobody mistakes mock data for the page.
 * `tokens` (CHG-050) is how the HTTP client signs its requests; the mock never uses it.
 */
export function createApi(tokens?: TokenSource): {
  api: ConsoleApi;
  mode: ApiMode;
  baseUrl: string | null;
} {
  const baseUrl = (import.meta.env.VITE_API_BASE_URL as string | undefined)?.trim();
  if (baseUrl)
    return { api: new HttpConsoleApi(baseUrl, undefined, tokens), mode: 'http', baseUrl };
  return { api: new MockConsoleApi(), mode: 'mock', baseUrl: null };
}
